module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/pref02#pref02"
    }
  }, [_c('em', [_vm._v("List of Maps and Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/pref03#pref03"
    }
  }, [_c('em', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/pref04#pref04"
    }
  }, [_c('em', [_vm._v("List of Terms and Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/pref05#pref05"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/pref06#pref06"
    }
  }, [_c('em', [_vm._v("Preface and Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch00#ch00"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch00a#ch00a"
    }
  }, [_vm._v("Prologue: The Call of the Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("Chapter 1. The International Geophysical Year: Idea to Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2. All Hands on Deck: Logistics for the High Latitudes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3. Gaining a Foothold: Operations Base at McMurdo Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4. Little America V: Science Flagship on the Ice Shelf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5. Marie Byrd Land: Crevasse Junction, Privation Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6. South Pole: Dropped From the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7. The Gap Stations: Hallett, Wilkes, and Ellsworth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8. On the Eve: People, Preparations, Policies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9. Comprehending the Cold: Antarctic Weather Quest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10. Looking Up: The Physics of the Atmosphere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11. Under Foot: Ice by the Mile")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12. Life on the Ice: The Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/app01#app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Science and Peace, Continuity and Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/app02#app02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0